import React from "react";
import i18n from "translation";
import { Box, SxProps, Theme, useTheme } from "@mui/material";
import { queryOps } from "system/query/Query";
import QuerySegmentContainer, { QuerySegmentProps } from "components/queries/queryBuilder/common/QuerySegmentContainer";
import { colorsAndLabelsByOp, makeBoxStyles } from "system/query/QueryUtility";
import { QueryBranch } from "system/query/QueryBranch";

export interface QueryBranchViewerProps extends QuerySegmentProps {
  queryBranch: QueryBranch;
}

export default function QueryBranchViewer(props: QueryBranchViewerProps): JSX.Element {
  const theme = useTheme();

  const queryBranch = props.queryBranch;
  const { borderColor, borderColorTop, backgroundColor, label, shortLabel } = colorsAndLabelsByOp(i18n, theme.colors.namedColors, queryBranch.op);
  let displayLabel = label;
  if (shortLabel) {
    displayLabel = shortLabel;
  }

  const isOr = queryBranch.op === queryOps.or,
        isNot = queryBranch.op === queryOps.not;
  if (isOr && queryBranch.quorum && queryBranch.quorum > 1) {
    displayLabel = `${queryBranch.quorum} +`;
  }
  if (isNot && queryBranch.quorum && queryBranch.quorum > 1) {
    displayLabel = `< ${queryBranch.quorum}`;
  }

  const branchChildren = queryBranch?.values && queryBranch?.values?.map((value, index) => {
    return (
      <QuerySegmentContainer
        key={index}
        depth={props.depth + 1}
        parent={queryBranch}
        path={`${props.path}.values.${index}`}
        queryInfo={props.queryInfo}
        inSpan={props.inSpan}
        spanSide={props.spanSide}
        isViewerMode={true}
        querySegment={value}
        editSegment={props.editSegment}
        addSegment={props.addSegment} />
    );
  });

  const sxProps:SxProps<Theme> = makeBoxStyles(backgroundColor, borderColor, borderColorTop);
  const containerSX:SxProps<Theme> = {
    minWidth: '400px',
    maxWidth: '100%',
    position: 'relative',
    padding: "6px 2px 8px 18px",
    '&:before': {
      ...sxProps,
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      width: '330px',
      maxWidth: '100%',
      content: '""',
    },
    '&:after': {
      content: `"${displayLabel}"`,
      opacity: 0.7,
      position: 'absolute',
      fontSize: '0.7rem',
      transform: 'rotate(90deg)',
      transformOrigin: 'left top 0',
      top: '6px',
      left: '17px',
    }
  }

  return (
    <Box sx={{...containerSX}}>
        {branchChildren}
    </Box>
  );
}
